export default __webpack_public_path__ + "static/media/transfer.165a35be.svg";